<template>
    <div class="question-wrap ml-2 ml-md-3">
        <div class="" id="questionPop">
            <span class="btn btn-sm btn-primary" @mouseover="showPopupClass = 'showme'" @mouseleave="showPopupClass = '' ">
                <question class="black-svg svg-18"></question>
                Help
            </span>
            <div class="question-content" id="questionPopContent" :class="showPopupClass" @mouseover="showPopupClass = 'showme'" @mouseleave="showPopupClass = ''">
                <div class="question-content-wrap">
                    <div class="contact--email">
                        <a :href="'mailto:' + emailaddress" class="help-link-ahref">
                            <email class="svg-24 accent-svg"></email>
                            <div class=""><label>Email</label>
                                <span v-text="emailaddress"></span>
                            </div>
                        </a>
                    </div>
                    <div class="contact--download">
                        <a href="https://www.emmys.com/awards/honors" target="_blank" class="help-link-ahref">
                            <linkicon class="svg-24 accent-svg"></linkicon>
                            <div class="">
                                <label>Link</label>
                                <span>Honors Information</span>
                            </div>
                        </a>
                    </div>
                </div>
        </div>
    </div>
</div>
</template>

<script>

    import question from './icons/question.vue';
    import email from './icons/email.vue';
    import linkicon from './icons/link.vue';
    import phone from './icons/phone.vue';
    export default {
        props: ['emailaddress', 'phone'],
        components: { question, email, linkicon, phone },
        data() {
            return {
                showPopupClass: '',
            }
        },
    }
</script>

<style>
</style>
